import { defineStore } from "pinia";
import { ref, watch } from "vue";

export const useLoginStore = defineStore("auth", () => {
  const user_id = ref(localStorage.getItem("_id") ?? null);
  const user_nombre = ref(localStorage.getItem("_nombre") ?? null);
  const userStoreToken = ref(localStorage.getItem("_token") ?? null);
  const userStoreModules = ref(localStorage.getItem("_modulos") ?? []);
  
  return {
    user_id,
    user_nombre,
    userStoreToken,
    userStoreModules
  };
});
